import { render, staticRenderFns } from "./matchitem.vue?vue&type=template&id=3b203ca6&scoped=true"
import script from "./matchitem.vue?vue&type=script&lang=js"
export * from "./matchitem.vue?vue&type=script&lang=js"
import style0 from "./matchitem.vue?vue&type=style&index=0&id=3b203ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b203ca6",
  null
  
)

export default component.exports